module.exports = __webpack_public_path__ + "static/media/53c0RsHhUoo.ef4d5e9f.png";